import React, { FC } from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import PruRoute from 'src/app/common/components/PruRoute';

import {
  WALLET_BASE_PATH,
  WALLET_BULKUPLOAD_PATH,
  WALLET_BULKUPLOAD_UPLOAD_STATUS_PATH,
} from 'src/app/modules/pruwallet/constants';
import BulkUploadStatusListingPage from './list/BulkUploadStatusListingPage';
import BulkUploadStatusFailedListingPage from './FailedList/BulkUploadFailedListingPage';

export const uploadPath = `${WALLET_BASE_PATH}${WALLET_BULKUPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_STATUS_PATH}`;

const BulkUploadStatusRoutes: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Redirect exact from={uploadPath} to={`${uploadPath}/list`} />
      <PruRoute exact path={`${uploadPath}/list`} component={BulkUploadStatusListingPage} />
      <PruRoute exact path={`${uploadPath}/:id/failed/list`} component={BulkUploadStatusFailedListingPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default BulkUploadStatusRoutes;
